<template>
    <div id="app">
        <router-view />
        <Dev v-if="showSiteDetails" />
        <transition name="fade">
            <FeedbackToast
                v-if="currentToast"
                :action-label="currentToast.actionLabel"
                :color="currentToast.color"
                :is-error="currentToast.isError"
                :is-loading="currentToast.isLoading"
                :label="currentToast.label"
                @action="toastActionHandler"
                @close="closeToast"
            />
        </transition>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { defineAsyncComponent } from 'vue';

    import idb from 'idb';
    import FeedbackToast from 'source/components/_generics/FeedbackToast.vue';

    export default {
        name: 'App',

        components: {
            Dev: defineAsyncComponent(() => import('./Dev.vue')),
            FeedbackToast
        },

        eventBusCallbacks: {
            'trigger-toast': 'openToast',
            'reset-toast-queue': 'resetToastQueue',
            'close-toast': 'closeToast'
        },

        data() {
            return {
                // toast data
                currentToast: null
            };
        },

        computed: {
            ...mapState('generics', ['sites']),
            ...mapState('auth', ['user']),

            showSiteDetails() {
                return this.sites.BRANCH_ENV != 'master' && this.sites.BRANCH_ENV != '';
            }
        },

        watch: {
            '$route.name': {
                handler() {
                    if (this.$route.query.desktop_user_id &&
                        this.$route.query.desktop_employment_id) {
                        if (this.$route.query.desktop_user_id != this.user.pk) {
                            this.performLogout();
                        } else {
                            this.$router.replace({
                                query: {
                                    ...this.$route.query,
                                    desktop_user_id: undefined,
                                    desktop_employment_id: undefined
                                }
                            });
                        }
                    }
                }
            },

            user: {
                async handler() {
                    if (!this.user) {
                        // Delete Indexed DB cahed data
                        await idb.reset().catch(e => console.error(e));
                    }
                }
            }
        },

        created() {
            this.fetchCurrencies();
        },

        methods: {
            ...mapActions('generics', ['fetchCurrencies']),
            ...mapActions('auth', ['performLogout']),

            openToast(payload) {
                this.currentToast = null;

                requestAnimationFrame(() => {
                    this.currentToast = {
                        'actionEvent': payload.actionEvent,
                        'actionLabel': payload.actionLabel,
                        'color': payload.color,
                        'isError': payload.isError,
                        'isLoading': payload.isLoading,
                        'label': payload.label
                    };
                });
            },

            closeToast(fromToastActionHandler) {
                // fromToastActionHandler lets us know if we pressed the `actionLabel` button or not
                // in this specific case, I want to perform an operation when pressing
                // the close button
                if (this.currentToast?.actionEvent?.payload?.parent && !fromToastActionHandler) {
                    const payload = this.currentToast.actionEvent.payload;
                    const parent = payload.parent;

                    let data = {
                        executivePk: payload.pk,
                        companyPk: payload.companyId,
                        action: 'revoke'
                    };

                    parent.updateExecutive(data);
                }

                this.currentToast = null;
            },

            toastActionHandler() {
                this.$eventBus.$emit(
                    this.currentToast.actionEvent.name,
                    this.currentToast.actionEvent.payload
                );
                this.closeToast(true);
            }
        }
    };
</script>
